import { ReactNode } from 'react'

import { Text } from '@hhgtech/hhg-components'
import { IntlFormatters } from 'react-intl'

import { WeekOfPregnancyApi } from 'interfaces/types'
function isValidNumeric(str: string) {
  if (typeof str !== 'string') return false // we only process strings!
  return (
    !isNaN(str as any) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
    !isNaN(parseFloat(str)) &&
    parseFloat(str) !== 0
  ) // ...and ensure strings of whitespace fail
}
export const renderWeekHeader = ({
  selectedWeek,
  data,
  isMobile,
  f,
}: {
  selectedWeek: number
  data: WeekOfPregnancyApi
  isMobile: boolean
  f: IntlFormatters['formatMessage']
}) => {
  if (selectedWeek <= 3)
    return f(
      {
        id: 'pregnancyTool.description.conceived',
        defaultMessage: 'Your Baby <b>has yet to be conceived</b>',
      },
      {
        b: function Component(chunks: ReactNode[]) {
          return (
            <Text as="span" size={isMobile ? 's3' : 's4'} type="semiBold">
              {chunks}
            </Text>
          )
        },
      },
    )

  if (isValidNumeric(data.height) && isValidNumeric(data.weight))
    if (data.fruit_name && data.fruit_name !== '') {
      return f(
        {
          id: 'pregnancyTool.description.withFullMeasurement',
          defaultMessage:
            'Your Baby is <height>cm</height> & <weight> kg</weight> and as big as a <fruitName></fruitName>',
        },
        {
          height: function Component(chunks: ReactNode[]) {
            return (
              <Text as="span" size={isMobile ? 's3' : 's4'} type="semiBold">
                {data.height} {chunks}
              </Text>
            )
          },
          weight: function Component(chunks: ReactNode[]) {
            return (
              <Text as="span" size={isMobile ? 's3' : 's4'} type="semiBold">
                {data.weight} {chunks}
              </Text>
            )
          },
          fruitName: function Component() {
            return (
              <Text as="span" size={isMobile ? 's3' : 's4'} type="semiBold">
                {data.fruit_name}
              </Text>
            )
          },
        },
      )
    } else {
      return f(
        {
          id: 'pregnancyTool.description.withMeasurement',
          defaultMessage:
            'Your Baby is <height>cm</height> & <weight> kg</weight> ',
        },
        {
          height: function Component(chunks: ReactNode[]) {
            return (
              <Text as="span" size={isMobile ? 's3' : 's4'} type="semiBold">
                {data.height} {chunks}
              </Text>
            )
          },
          weight: function Component(chunks: ReactNode[]) {
            return (
              <Text as="span" size={isMobile ? 's3' : 's4'} type="semiBold">
                {data.weight} {chunks}
              </Text>
            )
          },
        },
      )
    }

  return f(
    {
      id: 'pregnancyTool.description',
      defaultMessage: 'Your Baby is as big as a <fruitName></fruitName>',
    },
    {
      fruitName: function Component() {
        return (
          <Text as="span" size={isMobile ? 's3' : 's4'} type="semiBold">
            {data.fruit_name}
          </Text>
        )
      },
    },
  )
}
